import mod from "-!./peopleSport.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./peopleSport.js?vue&type=script&lang=js&external"